import { put, call, takeLatest, select } from 'redux-saga/effects';
import { login } from './actions';
import { resetStore, showVerificationCode, setMdnValidCode } from '../actions';
import * as api from './api';
import { getAuthRedirect } from 'reducers';

import { createSubmissionError } from 'forms/utils';
import * as routes from 'app/routes';
import { error, info } from 'notifications/actions';
import { getInitialTime, setInitialTime } from './utils';

export function* handleLogin({ payload: { email, password, recaptcha_token, device_uuid, verification_code, code_sending_mode, target_mdn } }) {
  try {
    const resp = yield call(api.login, email, password, recaptcha_token, device_uuid, verification_code, code_sending_mode, target_mdn);
    // need to enter verification code    
    if (resp.data && resp.data.status === '2fa_code_sent') {
      if (code_sending_mode === 'sms') {
        // indicator that provided mdn is valid
        yield put(setMdnValidCode(email, target_mdn));
      }
      const initialTime = getInitialTime(email, target_mdn);
      if (!initialTime) {
        setInitialTime(email, target_mdn);
      }
      const defaultTimerTime = 600;
      const timerTime = initialTime || defaultTimerTime;
      yield put(showVerificationCode(timerTime));
    // successfully login
    } else {
      yield put(resetStore());
      yield put(login.success(resp));
      const redirectTo = yield select(getAuthRedirect);
      yield put(
        redirectTo || routes.home()
      );
      yield put(info('general', 'Login was successful'));
    }
  }
  catch (err) {
    const { response } = err;
    if (response && response.status === 400 && response.data && response.data.code_sending_mode) {
      yield put(showVerificationCode());
    } else {
      const submissionError = createSubmissionError(response);
      yield put(login.failure(submissionError));
      yield put(error('login', response.data.detail || response.data.message || response.data.device_verification_code));
    }
  }
}

export function* watchHandleLogin() {
  yield takeLatest(login.REQUEST, handleLogin);
}
